import { Node, NodeViewProps, mergeAttributes } from '@tiptap/core';
import React from 'react';
import {
  NodeViewWrapper,
  NodeViewContent,
  ReactNodeViewRenderer,
} from '@tiptap/react';
import Image from 'next/image';
import Link from 'next/link';

import RiExternalLinkLine from '~icons/ri/external-link-line';

export type EmbedType = 'youtube' | 'playlist';

export const EmbedBlock = Node.create({
  name: 'embed',
  group: 'block',
  atom: true,
  addAttributes() {
    return {
      type: { default: 'youtube' },
      url: { default: null },
      title: { default: null },
      thumbnail: { default: null },
      width: { default: 480 },
      height: { default: 360 },
    };
  },
  parseHTML() {
    return [{ tag: 'div[data-type="embed"]' }];
  },
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'embed' })];
  },
  addNodeView() {
    return ReactNodeViewRenderer(EmbedBlockComponent);
  },
});

const EmbedBlockComponent: React.FC<NodeViewProps> = ({ node }) => {
  const { url, type, title, thumbnail, width, height } = node.attrs;

  if (!url) return null;

  return (
    <NodeViewWrapper className="not-prose my-5 flex w-full flex-col">
      <div className="not-prose">
        {type === 'youtube' || type === 'playlist' ? (
          <Link
            href={url}
            target="_blank"
            className={
              'from- flex flex-row items-center overflow-hidden rounded-xl bg-[#0B0B0B] duration-200 ease-in-out hover:brightness-150'
            }
          >
            <div className="relative">
              <img
                src={thumbnail || 'https://via.placeholder.com/90x90'}
                width={256}
                height={96}
                className="object-cover"
                style={{ height: '86px' }}
              />
            </div>

            <section
              className={
                'flex w-full flex-row items-center justify-between gap-4 px-5'
              }
            >
              <div>
                <p className={'text-sm font-bold'}>
                  {type === 'playlist' ? 'Плейлист' : 'Видео'}
                </p>
                <p className={'line-clamp-1 text-sm'}> {title}</p>
              </div>
              <div>
                <RiExternalLinkLine className={'ml-3 w-8'} />
              </div>
            </section>
          </Link>
        ) : null}
      </div>
      <NodeViewContent />
    </NodeViewWrapper>
  );
};
